import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { ButtonField, ButtonFieldList } from '../helperComponents';
export function usePrefixButton({ button, prefixIcon, size, disabled, readonly, onFocus, onBlur, }) {
    const buttonListRef = useRef(null);
    const prefixIconProps = useMemo(() => ({
        id: 'prefixIcon',
        active: false,
        show: Boolean(prefixIcon && !button),
        render: () => _jsx(_Fragment, { children: prefixIcon }),
    }), [button, prefixIcon]);
    const prefixButtonProps = useMemo(() => ({
        id: 'prefixButton',
        active: false,
        show: Boolean(button && button.variant === 'before'),
        render: renderProps => {
            const buttonProps = Object.assign(Object.assign({}, renderProps), { variant: 'before', size, content: button === null || button === void 0 ? void 0 : button.content, disabled: disabled || readonly, onFocus,
                onBlur });
            if (button === null || button === void 0 ? void 0 : button.items) {
                return (_jsx(ButtonFieldList, Object.assign({}, buttonProps, { ref: buttonListRef, onClick: () => {
                        setTimeout(() => { var _a; return (_a = buttonListRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 0);
                    }, items: button.items, selection: button.selection, open: button.open, onOpenChange: button.onOpenChange })));
            }
            return _jsx(ButtonField, Object.assign({}, buttonProps));
        },
    }), [button, size, disabled, readonly, onFocus, onBlur]);
    return button ? prefixButtonProps : prefixIconProps;
}
